// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const mva: CountryValidator<"NO"> = createValidator(
  "no.mva",
  138,
);

export default mva;
export const compact = mva.compact;
export const format = mva.format;
export const validate = mva.validate;
export const generate = (): string =>
  mva.generate?.() ??
  (() => {
    throw new Error(
      "Validator no.mva cannot generate values",
    );
  })();
